import type { SVGProps } from "react";
export interface QuoteRightIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function QuoteRightIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: QuoteRightIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 14V7A.875.875 0 0 0 20 6.125h-4a.875.875 0 0 0-.875.875v4c0 .483.392.874.874.874H18c.621 0 1.125.505 1.125 1.125v1.766c0 1.11-.588 2.13-1.533 2.69l-.195.105-.088.042.064.253A3.874 3.874 0 0 0 20.875 14m2.25 0A6.124 6.124 0 0 1 17 20.125h-.5c-.515 0-.965-.351-1.09-.852l-.502-2a1.126 1.126 0 0 1 .59-1.28l.893-.446.107-.063a.88.88 0 0 0 .377-.72v-.64H16A3.125 3.125 0 0 1 12.875 11V7a3.125 3.125 0 0 1 3.124-3.125H20A3.125 3.125 0 0 1 23.125 7zm-14.25 0V7A.875.875 0 0 0 8 6.125H4A.875.875 0 0 0 3.125 7v4c0 .483.391.874.875.874h2c.621 0 1.125.505 1.125 1.125v1.766c0 1.11-.588 2.13-1.533 2.69l-.195.105-.088.042.065.253A3.874 3.874 0 0 0 8.874 14Zm2.25 0A6.124 6.124 0 0 1 5 20.125h-.5c-.515 0-.965-.351-1.09-.852l-.502-2a1.125 1.125 0 0 1 .59-1.28l.893-.446.107-.063a.88.88 0 0 0 .377-.72v-.64H4A3.125 3.125 0 0 1 .875 11V7A3.125 3.125 0 0 1 4 3.875h4A3.125 3.125 0 0 1 11.124 7z"
      />
    </svg>
  );
}
